import { Component, OnInit } from '@angular/core';
import { MenuProduto } from '../models/menuproduto';
import { TipoCampoPersonalizado } from '../models/enum';
import { MatDialog } from '@angular/material';
import { AdicionarMenuProdutoModalComponent } from '../modals/adicionar-menu-produto-modal/adicionar-menu-produto-modal.component';
import { MenuProdutoService } from '../services/menuprodutoservice';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-loja-de-produtos-config',
  templateUrl: './loja-de-produtos-config.component.html',
  styleUrls: ['./loja-de-produtos-config.component.scss']
})
export class LojaDeProdutosConfigComponent implements OnInit {
  menus: MenuProduto[] = [];

  constructor(
    public dialog: MatDialog,
    public menuProdutoService: MenuProdutoService,
    public notificacaoService: NotificacaoService,
    public carregandoService: CarregandoService
  ) { }

  ngOnInit() {
    this.buscarMenu();
  }

  adicionarMenu() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(AdicionarMenuProdutoModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarMenu();
      }
    });
  }

  buscarMenu() {
    this.carregandoService.mostra('buscarmenu');

    this.menuProdutoService.consultarListaMenu().subscribe(menus => {
      this.menus = [];
      this.menus = menus;
      this.carregandoService.esconde('buscarmenu');
    }, (error) => {
      this.notificacaoService.erro(error);
      this.carregandoService.esconde('buscarmenu');
    });
  }
}
